import React from "react";
import { Modal, Row, Col } from "antd";

const RowForm = props => (
  <Row style={{ padding: " 5px 10px" }}>{props.children}</Row>
);

class ModalBranchDetail extends React.Component {
  render() {
    const { data } = this.props;

    return (
      <Modal
        title="Branch Detail"
        visible={this.props.visible}
        onOk={() => this.props.visibleModal()}
        onCancel={() => this.props.visibleModal()}
        width={700}>
        <p>Branch Detail</p>

        <RowForm>
          <Col span={8}>Branch</Col>
          <Col span={16}>: {data ? data.partnerName : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Branch Code</Col>
          <Col span={16}>: {data ? data.code : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Bracnh Head</Col>
          <Col span={16}>
            :{" "}
            {data
              ? data.BranchHead
                ? data.BranchHead.User
                  ? data.BranchHead.User.name
                  : null
                : null
              : null}
          </Col>
        </RowForm>
        <RowForm>
          <Col span={8}>TNT</Col>
          <Col span={16}>
            :{" "}
            {data
              ? data.TNTProfile
                ? data.TNTProfile.User
                  ? data.TNTProfile.User.name
                  : null
                : null
              : null}
          </Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Pricing Area</Col>
          <Col span={16}>
            : {data ? (data.AreaPricing ? data.AreaPricing.name : null) : null}
          </Col>
        </RowForm>

        <RowForm>
          <Col span={8}>New Car Area</Col>
          <Col span={16}>
            : {data ? (data.Area ? data.Area.name : null) : null}
          </Col>
        </RowForm>

        <RowForm>
          <Col span={8}>Cabang Area</Col>
          <Col span={16}>
            : {data ? (data.AreaBranch ? data.AreaBranch.name : null) : null}
          </Col>
        </RowForm>

        <RowForm>
          <Col span={8}>Business Area</Col>
          <Col span={16}>
            :{" "}
            {data ? (data.AreaBusiness ? data.AreaBusiness.area : null) : null}
          </Col>
        </RowForm>
      </Modal>
    );
  }
}

export default ModalBranchDetail;



// WEBPACK FOOTER //
// src/components/Dashboard/Branch/Modal/ModalBranchDetail.js